$(document).ready(function () {
  const $grid = $('.bh2-grid');
  const $pills = $('.bh2-pill');
  const $allPill = $('.bh2-pill.all');
  const $loadMoreBtn = $('#bh2-load-more-btn');

  let activeFilters = []; // Array to store multiple category slugs
  let visibleCount = 12;  // Base pagination limit

  // Initialize display on page load
  updateGridDisplay();

  // --- 1. Filter Bar Event Handler ---
  // (This MUST be declared first so the click event exists in browser memory)
  $pills.on('click', function () {
    const $clickedPill = $(this);
    const clickedFilter = $clickedPill.attr('data-filter');

    // Reset pagination index whenever a filtering action happens
    visibleCount = 12;

    if (clickedFilter === 'all') {
      activeFilters = [];
      $pills.removeClass('is-active');
      $allPill.addClass('is-active');
    } else {
      $allPill.removeClass('is-active');
      $clickedPill.toggleClass('is-active');

      if ($clickedPill.hasClass('is-active')) {
        activeFilters.push(clickedFilter);
      } else {
        activeFilters = activeFilters.filter(item => item !== clickedFilter);
      }

      if (activeFilters.length === 0) {
        $allPill.addClass('is-active');
      }
    }

    updateGridDisplay();
  });

  // --- 2. Load More / Reset Button Event Handler ---
  $loadMoreBtn.on('click', function () {
    if ($(this).hasClass('is-reset-mode')) {
      visibleCount = 12;
      activeFilters = [];
      $pills.removeClass('is-active');
      $allPill.addClass('is-active');
    } else {
      visibleCount += 6;
    }

    updateGridDisplay();
  });

  // --- 3. Dynamic URL Sub-Page Path Filter Checker ---
  // (Moved here so it can successfully call the click event registered above)
  const cleanPath = window.location.pathname.replace(/^\/|\/$/g, '');
  const pathSegments = cleanPath.split('/');

  if (pathSegments.length >= 2 && pathSegments[0] === 'resources') {
    const categorySlug = pathSegments[2];

    if (categorySlug && categorySlug !== '') {
      const $targetPill = $pills.filter(`[data-filter="${categorySlug}"]`);

      if ($targetPill.length) {
        // Now that the listener is live, this will successfully fire!
        $targetPill.trigger('click');
      }
    }
  }

  // --- Core Processing Engine ---
  function updateGridDisplay() {
    let $filteredSelection;

    if (activeFilters.length === 0) {
      $filteredSelection = $grid.find('.bh2-post');
    } else {
      const selectorString = activeFilters.map(cat => `.bh2-post[data-cat="${cat}"]`).join(', ');
      $filteredSelection = $grid.find(selectorString);
    }

    $grid.find('.bh2-post').removeClass('show');
    $filteredSelection.slice(0, visibleCount).addClass('show');

    const totalMatchedItems = $filteredSelection.length;

    if (totalMatchedItems <= 12) {
      $loadMoreBtn.hide().removeClass('is-reset-mode').text('Load More');
    } else if (visibleCount >= totalMatchedItems) {
      $loadMoreBtn.show().addClass('is-reset-mode').text('Reset Posts');
    } else {
      $loadMoreBtn.show().removeClass('is-reset-mode').text('Load More');
    }
  }
});
